import { createContext, useContext, useEffect, useMemo, useState } from "react";
import useSWR from "swr";
import { api } from "./api";

const fetcher = (url) => api.get(url).then((r) => r.data);

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const { data: content } = useSWR("/content", fetcher, { revalidateOnFocus: false });
  const { data: screenshots } = useSWR("/screenshots", fetcher, { revalidateOnFocus: false });
  const [lang, setLangState] = useState(() => localStorage.getItem("7ala9_lang") || "ar");

  useEffect(() => {
    document.documentElement.dir = lang === "fr" ? "ltr" : "rtl";
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("7ala9_lang", l);
    setLangState(l);
  };

  // Resolve translated content: French sections override Arabic when provided,
  // empty French contact fields fall back to the Arabic defaults (WhatsApp number etc.).
  const tc = useMemo(() => {
    if (!content) return content;
    if (lang !== "fr" || !content.fr) return content;
    const out = { ...content };
    Object.entries(content.fr || {}).forEach(([k, v]) => {
      if (v == null || (typeof v === "object" && Object.keys(v).length === 0)) return;
      if (k === "contact" && typeof v === "object") {
        const cleaned = Object.fromEntries(Object.entries(v).filter(([, x]) => x !== "" && x != null));
        out[k] = { ...content[k], ...cleaned };
      } else {
        out[k] = v;
      }
    });
    return out;
  }, [content, lang]);

  return (
    <SiteCtx.Provider value={{ content, tc, screenshots, lang, setLang }}>
      {children}
    </SiteCtx.Provider>
  );
}

export const useSite = () => useContext(SiteCtx);
